import { Link } from "react-router-dom";
import { mangaList, latestUpdates } from "@/mocks/mangaList";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestUpdates() {
  const rows = latestUpdates
    .map((item) => {
      const manga = mangaList.find((m) => m.id === item.mangaId);
      return manga ? { ...item, manga } : null;
    })
    .filter((row): row is NonNullable<typeof row> => row !== null);

  return (
    <section className="border-y border-background-200 bg-background-100/70" aria-labelledby="latest-heading">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          title="最新更新"
          subtitle="热门漫画章节实时同步,追更不迷路"
          moreTo="/category"
          moreLabel="更多更新"
        />
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {rows.map((row) => (
            <Link
              key={row.chapterId}
              to={`/article/${row.chapterId}`}
              className="group flex items-center gap-4 rounded-lg bg-background-50 p-3 transition-all hover:border-primary-300"
              title={`阅读${row.manga.title}${row.chapterTitle}`}
            >
              <div className="relative h-20 w-14 shrink-0 overflow-hidden rounded-md">
                <img
                  src={row.manga.cover}
                  alt={`${row.manga.title}漫画`}
                  title={`${row.manga.title}漫画免费阅读`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                  {row.manga.title}
                </h3>
                <p className="mt-1 truncate text-xs text-foreground-600">{row.chapterTitle}</p>
                <p className="mt-1.5 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line" aria-hidden="true" />
                  {row.time}
                </p>
              </div>
              <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 sm:flex">
                立即阅读
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}